import React from 'react';
import { FormattedMessage } from 'react-intl';
import type { JsonApiResponseSingle } from 'json-api-normalizer';

import { wrapWithStore } from 'helpers/store';
import { MainTitles, Title } from 'components/MainTitles/MainTitles';
import LandingApp from 'LandingApp';

import Faq from './Faq';

interface Props {
  faq?: JsonApiResponseSingle;
}

function FaqPage({ faq }: Props) {
  return (
    <LandingApp>
      <MainTitles>
        <Title>
          <FormattedMessage id="faq.title" />
        </Title>
      </MainTitles>

      <Faq savedFaqData={faq} />
    </LandingApp>
  );
}

export default wrapWithStore(FaqPage);
